import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { styled } from "styled-components";
const StyledHeaderLink = styled.a `
  align-items: left;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: #51E0CF;
  font-family: var(--netx-font);
  font-size: 14px;
  width: fit-content;
  font-weight: 400;
  padding: 10px 0 27px;
  white-space: nowrap;
  transition: 0.5s;

`;
const StyledLink = styled.a `
  text-decoration: underline;
  cursor: pointer;
  font-family: var(--netx-font);
  color: ${({ theme }) => theme.text1};
  font-weight: 400;

  :hover {
    text-decoration: none;
  }

  :focus {
    outline: none;
    text-decoration: none;
  }

  :active {
    text-decoration: none;
  }
`;
export function ExternalHeaderLink({ target = '_blank', href, rel = 'noopener noreferrer', ...rest }) {
    const handleClick = useCallback((event) => {
    }, [href, target]);
    return _jsx(StyledHeaderLink, { target: target, rel: rel, href: href, onClick: handleClick, ...rest });
}
/**
 * Outbound link that handles firing google analytics events
 */
export function ExternalLink({ target = '_blank', href, rel = 'noopener noreferrer', ...rest }) {
    const handleClick = useCallback((event) => {
        // if (target === '_blank' || event.ctrlKey || event.metaKey) {
        // } else {
        //   event.preventDefault()
        // }
    }, [href, target]);
    return _jsx(StyledLink, { target: target, rel: rel, href: href, onClick: handleClick, ...rest });
}
